import React from 'react'
import ContactForm from '../Home/ContactForm'

const Contact = () => {
  return (
    <div>
        <ContactForm/>
    </div>
  )
}

export default Contact